import { Outlet } from 'react-router-dom';
import { TestId } from '@repo/test-id';

import Header from '@features/account/components/Header';

export default function RegistrationLayout() {
  const testId = TestId.root('registrationLayout');

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
        <div className="md:hidden">
          <Header testId={testId.append('header')} />
        </div>

        <Outlet />
      </div>
    </div>
  );
}
